import { render } from "./WarenkorbItemComponent.vue?vue&type=template&id=427e1820&scoped=true"
import script from "./WarenkorbItemComponent.vue?vue&type=script&lang=js"
export * from "./WarenkorbItemComponent.vue?vue&type=script&lang=js"

import "@/styles/WarenkorbItemComponent.css?vue&type=style&index=0&id=427e1820&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427e1820"]])

export default __exports__